import { render } from "./TestIndex.vue?vue&type=template&id=3a0a5c92"
import script from "./TestIndex.vue?vue&type=script&lang=js"
export * from "./TestIndex.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__